export enum EApplicationsQueryKey {
  APPLICATION = 'APPLICATION',
  APPLICATIONS = 'APPLICATIONS',
  APPLICATION_DEALERSHIPS = 'APPLICATION_DEALERSHIPS',
  SEARCH_APPLICATION = 'SEARCH_APPLICATION',
}
